import { Price } from '../../price/Price';
import { MoreProductsBadge, ProductContent, ProductsPreviewContainer, Title } from './styles';
import { ProductsPreviewProps } from './types';

export const ProductsPreview = ({ products, onClick }: ProductsPreviewProps) => {
    const availableProducts = products.filter((product) => !product.isUnavailable);

    if (!availableProducts.length) {
        return null;
    }

    const firstProduct = availableProducts[0];
    const { title, priceInfo, oldPriceInfo, fintechDiscount } = firstProduct;
    const moreProductsCount = availableProducts.length - 1;

    return (
        <ProductsPreviewContainer onClick={onClick}>
            <ProductContent>
                <Title>{title}</Title>
                <Price
                    priceInfo={priceInfo}
                    oldPriceInfo={oldPriceInfo}
                    variant="body2"
                    showOldPriceBadge
                    hideOldPrice
                    fintechDiscount={fintechDiscount}
                    fintechDiscountOptions={{ compact: true }}
                />
            </ProductContent>
            {moreProductsCount > 0 ? (
                <MoreProductsBadge>{`+${moreProductsCount}`}</MoreProductsBadge>
            ) : null}
        </ProductsPreviewContainer>
    );
};
